import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NgbdGridJsSortableHeader, SortEvent } from 'src/app/pages/tables/gridjs/gridjs-sortable.directive';
import * as XLSX from 'xlsx';

export interface Thead {
	text: string;
	key: string;
	visible: boolean;
	type: string;
	order: string;
	align?: string;
	cell_class?: any[];
	icon?: string;
}

export interface CellClass {
	value: string;
	class: string;
	operator: string;
}

export interface Btn {
	text: string;
	size: string;
	color: string;
}

export interface Icon {
	name: string;
	action: string;
	tooltip: string;
	align: string;
}

export interface Config {
	tableClass: string;
	theadClass?: string;
	dblclickRows?: boolean;
	columnSize?: Number[];
}

@Component({
	selector: 'app-table',
	templateUrl: './table.component.html',
	styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
	@Input() tableName: string;
	@Input() tableConfig: Config;
	@Input() buttons: Btn[] = [];
	@Input() theads: Thead[];
	@Input() count: boolean;
	@Input() data: any[];
	@Input() changeColor: string[];
	@Input() totales: boolean = false;
	@Input() isPagination = true;
	@Input() isHideColums = true;
	@Input() icons = false;
	@Input() activation = false;

	@Output() rowClicked = new EventEmitter<any>();
	@Output() button = new EventEmitter<any>();
	@Output() icon = new EventEmitter<any>();
	@Output() toogleActivation = new EventEmitter<any>();

	public paginacion = {
		pagina: 1,
		cantidad: 25,
		showData: [],
		totalPag: new Array(1),
	};

	public totalRow;

	constructor() {}

	ngOnInit() {
		if (!this.isPagination) {
			this.paginacion.cantidad = 10000;
		}
		if (this.data.length > 0) {
			this.paginacion.totalPag = new Array(Math.ceil(this.data.length / this.paginacion.cantidad));
		}
		this.imprimirPaginacion();

	}

	ngOnChanges() {
		this.imprimirPaginacion();
		if (this.totales) {
			this.getTotales();
		}
	}

	ngDoCheck() {
		this.imprimirPaginacion();
	}





	public setCellClass(index, record) {
		let clases = '';

		this.theads[index].cell_class.forEach((clase) => {
			switch (clase.operator) {
				case '==':
					if (clase.compareWith != '' || clase.compareWith != null) {
						if (clase.value == record[clase.compareWith]) {
							clases += clase.class + ' ';
						}
					} else if (clase.value == record[this.theads[index].key]) {
						clases += clase.class + ' ';
					}
					break;
				default:
					clases += clase.class + ' ';
					break;
			}
		});

		return clases;
	}

	public handleDblClick(record) {
		if (this.tableConfig.dblclickRows) {
			this.rowClicked.emit(record);
		}
	}

	public pressButton(record, button) {
		this.button.emit({
			record: record,
			button: button,
		});
	}

	public pressIcon(record, icon) {
		this.icon.emit({
			record: record,
			icon: icon,
		});
	}

	exportExcel(id) {
		let element = document.getElementById(id);
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		XLSX.writeFile(wb, 'Export_Data.xlsx');
	}

	public setType(type) {
		switch (type) {
			case 'currency':
				return "currency: 'USD'";
			case 'mediumDate':
				return "date: 'mediumDate'";
			case 'medium':
				return "date: 'medium'";
			case 'short':
				return "date: 'short'";
		}
	}

	public imprimirPaginacion() {
		if (this.data.length > 0) {
			this.paginacion.totalPag = new Array(Math.ceil(this.data.length / this.paginacion.cantidad));
		}
		if (this.paginacion.totalPag.length < this.paginacion.pagina) {
			this.paginacion.pagina = this.paginacion.totalPag.length;
		}

		const from = this.paginacion.pagina * this.paginacion.cantidad - this.paginacion.cantidad;
		const to = this.paginacion.pagina * this.paginacion.cantidad - 1;
		this.paginacion.showData = this.data.slice(from, to + 1);
	}

	public isChangeColor(thead) {
		let change = false;
		this.changeColor.forEach((th) => {
			if (thead.key === th) {
				change = true;
			}
		});
		return change;
	}

	public getTotales() {
		this.totalRow = this.theads.map((thead, index) => {
			if (thead.type === 'number' || thead.type === 'currency') {
				const total = this.data.reduce((sum, dato) => {
					const num = parseFloat(dato[thead.key]) || 0;
					return sum + num;
				}, 0);
				return { type: thead.type, value: total };
			} else {
				return { type: thead.type, value: '' };
			}
		});
		this.totalRow[0].value = 'Totals';
	}

	toogleActive(row, newValue) {
		this.toogleActivation.emit({
			record: row,
			newValue: newValue,
		});
	}
}
